module.exports = __webpack_public_path__ + "img/shiting.741e8790.png";